import { getCardBrandIcon } from 'src/components/Selectors/BuyerSelector/BuyerCard';
import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './PaymentMethodCard.css';

type PaymentMethodCardProps = {
  cardBrand?: string | null;
  cardSummary?: string | null;
  expiryMonth?: number | null;
  expiryYear?: number | null;
  isDefault?: boolean;
};

export const PaymentMethodCard = ({
  cardBrand,
  cardSummary,
  expiryMonth,
  expiryYear,
  isDefault,
}: PaymentMethodCardProps) => {
  return (
    <div className={styles.cardInfo}>
      <span className={styles.cardNumber}>
        {getCardBrandIcon(cardBrand)} **** {cardSummary}
      </span>
      {expiryMonth != null && expiryYear != null && (
        <span className={styles.cardExpiry}>
          <Content id={ContentId.Expires} /> {expiryMonth}/{expiryYear}
        </span>
      )}
      {isDefault && (
        <span className={styles.cardBadge}>
          <Content id={ContentId.Default} />
        </span>
      )}
    </div>
  );
};
